import {
  GET_CMS,
  GET_CMS_FAILURE,
  GET_CMS_SUCCESS,
  UPDATE_CMS,
  UPDATE_CMS_FAILURE,
  UPDATE_CMS_SUCCESS,
  SHOW_CMS,
  SHOW_CMS_SUCCESS,
  SHOW_CMS_FAILURE
} from "../types";

export const getCMS = (payload) => ({
  type: GET_CMS,
  payload
});
export const getCMSSuccess = (payload) => ({
  type: GET_CMS_SUCCESS,
  payload,
});
export const getCMSFailure = (payload) => ({
  type: GET_CMS_FAILURE,
  payload,
});

export const updateCMS = (payload) => ({
  type: UPDATE_CMS,
  payload,
});
export const updateCMSSuccess = (payload) => ({
  type: UPDATE_CMS_SUCCESS,
  payload,
});
export const updateCMSFailure = (payload) => ({
  type: UPDATE_CMS_FAILURE,
  payload,
});

export const showCMS = (payload) => ({
  type: SHOW_CMS,
  payload,
});
export const showCMSSuccess = (payload) => ({
  type: SHOW_CMS_SUCCESS,
  payload,
});
export const showCMSFailure = (payload) => ({
  type: SHOW_CMS_FAILURE,
  payload,
});
